import { useContext } from 'react'
import { ToastContext } from '../components/container'

export const useToast = () => {
  const { pushToast, deleteToast } = useContext(ToastContext)
  return { pushToast, deleteToast }
}
